import RvIcon from '~/assets/icons/rv-small.svg';

import { cn } from '../../lib/utils/classname';

export type CheckboxInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
> & {};

const CheckboxInput: React.FC<CheckboxInputProps> = ({
  className,
  ...rest
}) => (
  <div
    className={cn(
      'relative flex transition-opacity',
      {
        'pointer-events-none opacity-50': rest.disabled,
      },
      className
    )}
  >
    <input
      type="checkbox"
      className="peer/checkbox relative h-6 w-6 opacity-0"
      {...rest}
    />

    <div className="pointer-events-none absolute top-0 left-0 flex h-full w-full items-center justify-center peer-checked/checkbox:[&_[data-overlay]]:scale-x-0">
      <div className="bg-brand-quaternary border-brand-primary relative flex h-3 w-3 items-center justify-center border-b text-white">
        <RvIcon />

        <div
          className="bg-brand-quaternary pointer-events-none absolute top-0 left-0 h-full w-full origin-right transition-transform"
          data-overlay
        />
      </div>
    </div>
  </div>
);

export default CheckboxInput;
